module.exports = __webpack_public_path__ + "img/p3.64543c09.png";